<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween">
    <h2 class="t-widgetTitle">
      <span *ngIf="isNew">
        {{ "translate.agentTasks.createNew" | translate }}
      </span>
      <span *ngIf="!isNew">
        {{ "translate.agentTasks.edit" | translate }}
      </span>
    </h2>
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div class="body-container">
  <div class="right-col">
    <!--title-->
    <input-wrap
      label="{{ 'translate.general.title' | translate }}"
      cssClass="l-cell-spread"
      [required]="true"
      [readonly]="taskUserSw"
    >
      <input
        type="text"
        [(ngModel)]="task.title"
        class="t-input t-input--colored"
        [disabled]="taskUserSw"
      />
    </input-wrap>

    <!--notes-->
    <input-wrap
      label="{{ 'translate.agentTasks.taskNotes' | translate }}"
      cssClass="l-cell-spread"
      [readonly]="taskUserSw"
    >
      <textarea
        dir="auto"
        class="t-input t-input--colored"
        [(ngModel)]="task.taskNotes"
        [disabled]="taskUserSw"
      ></textarea>
    </input-wrap>

    <!--agent notes-->
    <input-wrap
      label="{{ 'translate.agentTasks.agentNotes' | translate }}"
      cssClass="l-cell-spread"
    >
      <textarea
        dir="auto"
        class="t-input t-input--colored"
        [(ngModel)]="task.userNotes"
      ></textarea>
    </input-wrap>
  </div>

  <div class="left-col">
    <!--clinic-->
    <input-wrap
      label="{{ 'translate.general.clinic' | translate }}"
      [required]="true"
      cssClass="l-cell-spread"
      [loading]="clinicList && clinicList.loading"
      [readonly]="taskUserSw"
      [customValidation]="task.clinic != null"
    >
      <p-select
        class="t-input--colored"
        [options]="clinicList"
        [(ngModel)]="task.clinic"
        [placeholder]="'translate.general.choose' | translate"
        [optionLabel]="'clinicDescr'"
        [dataKey]="'clinicId'"
        [filter]="true"
        [resetFilterOnHide]="true"
        appendTo="body"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
        [disabled]="taskUserSw"
      ></p-select>
    </input-wrap>

    <!--agent-->
    <input-wrap
      label="{{ 'translate.general.taskUser' | translate }}"
      [required]="true"
      cssClass="l-cell-spread"
      [loading]="taskUsersList && taskUsersList.loading"
      [readonly]="taskUserSw"
      [customValidation]="task.taskUser != null"
    >
      <p-select
        class="t-input--colored"
        [options]="taskUsersList"
        [(ngModel)]="task.taskUser"
        [placeholder]="'translate.general.choose' | translate"
        optionLabel="label"
        [filter]="true"
        [resetFilterOnHide]="true"
        appendTo="body"
        [disabled]="taskUserSw"
      ></p-select>
    </input-wrap>

    <!--due date-->
    <input-wrap
      label="{{ 'translate.general.dueDate' | translate }}"
      cssClass="l-cell-spread"
      [readonly]="taskUserSw"
    >
      <p-datepicker
        class="t-input--colored"
        dateFormat="dd/mm/yy"
        [(ngModel)]="task.dueDate"
        readonlyInput="readonlyInput"
        showButtonBar="true"
        appendTo="body"
        [disabled]="taskUserSw"
      ></p-datepicker>
    </input-wrap>

    <!--status-->
    <input-wrap
      label="{{ 'translate.general.statusDescr' | translate }}"
      cssClass="l-cell-spread"
      [loading]="statusList && statusList.loading"
      [readonly]="taskUserSw"
    >
      <p-select
        class="t-input--colored"
        [options]="statusList"
        [(ngModel)]="task.status"
        [placeholder]="'translate.general.choose' | translate"
        [optionLabel]="'label'"
        appendTo="body"
        [disabled]="taskUserSw"
      ></p-select>
    </input-wrap>

    <!--completeDate-->
    <input-wrap
      [class.hidden]="!task.completeDate"
      label="{{ 'translate.general.completeDate' | translate }}"
      cssClass="l-cell-spread"
      [readonly]="true"
    >
      <p-datepicker
        class="t-input--colored"
        dateFormat="dd/mm/yy"
        [(ngModel)]="task.completeDate"
        readonlyInput="readonlyInput"
        showButtonBar="true"
        appendTo="body"
        [disabled]="true"
      ></p-datepicker>
    </input-wrap>
  </div>
</div>

<div class="footer">
  <div class="task-info">
    <p *ngIf="!isNew">
      {{ "translate.tasks.createdAt" | translate }}
      <span>{{ task.crDate | date : "dd/MM/yy HH:mm" }}</span>
      {{ "translate.tasks.createdBy" | translate }}
      <span>{{ task.createdBy.text }}</span>
    </p>
    <p *ngIf="task.updDate">
      {{ "translate.tasks.updatedAt" | translate }}
      <span>{{ task.updDate | date : "dd/MM/yy HH:mm" }}</span>
      {{ "translate.tasks.updatedBy" | translate }}
      <span>{{ task.updUser?.text }}</span>
    </p>
  </div>

  <div class="t-buttonSet">
    <button
      *ngIf="!isNew && task.status.id == 'OPEN'"
      [disabled]="saving || !saveEnabled()"
      (click)="completeTask()"
      class="t-button-outline"
    >
      {{ "translate.agentTasks.completeBtn" | translate }}
    </button>
    <button
      [disabled]="saving || !saveEnabled()"
      (click)="save()"
      class="t-button"
    >
      {{ "translate.agentTasks.updBtn" | translate }}
    </button>
  </div>
</div>
